import {ActionCreatorDefinition, createAction} from "redux-ts";
import {News} from "protocol/news/GetNewsResponse";

export const DoFetchNewsType: string = "DoFetchNews";
export const SetNewsType: string =  "SetNews";
export const SetSelectedNewsIdType: string = "SetSelectedNewsIdType"

export interface DoFetchNewsPayload {

}

export interface SetNewsPayload {

    news: News[];
}

export interface SetSelectedNewsIdPayload {
    id: string;
}

export const DoFetchNews: ActionCreatorDefinition<DoFetchNewsPayload, any> = createAction<DoFetchNewsPayload>(DoFetchNewsType);
export const SetNews: ActionCreatorDefinition<SetNewsPayload, any> = createAction<SetNewsPayload>(SetNewsType);
export const SetSelectedNewsId: ActionCreatorDefinition<SetSelectedNewsIdPayload, any> = createAction<SetSelectedNewsIdPayload>(SetSelectedNewsIdType)
